import {useLayoutEffect} from 'react';

/**
 * Adds "page" and "page--<pageType>" classes to document.body while the
 * calling component is mounted, removing them on unmount.
 *
 * Pass null/undefined to skip (useful for conditional page types).
 *
 * @param {string|null|undefined} pageType - e.g. 'home-page', '404', 'checkout', 'upsell'
 */
export const useBodyPageType = (pageType) => {
  useLayoutEffect(() => {
    if (!pageType) return;

    document.body.classList.add('page', `page--${pageType}`);

    return () => {
      document.body.classList.remove('page', `page--${pageType}`);
    };
  }, [pageType]);
};
